module.exports = __webpack_public_path__ + "static/media/lowerPeepSmall.e314dfce.svg";